import script from "./EditUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserModal.vue?vue&type=script&setup=true&lang=js"

import "./EditUserModal.vue?vue&type=style&index=0&id=35d27b21&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d27b21"]])

export default __exports__